import * as React from "react";
import { useAppSelector } from "../store/index";
import { RootState } from "../reducers/index";
import { IMapOptions } from "../interfaces/mapoptions";
import { Helmet } from "react-helmet-async";

const PoiListNone = () => {
    const mapoptions = useAppSelector<IMapOptions>((x: RootState) => x.mapoptions);

    const handleBack = (e) => {
        history.back();
        e.stopPropagation();
    }

    return (
        <div className="poi-error">
            <h3>We&rsquo;re Sorry...</h3>
            <p>
                We couldn't find any points of interest near the halfway point which
                match your search for <strong>{mapoptions.poi}</strong>.
            </p>
            <p>
                <span className="link-primary" onClick={handleBack} ><i className="material-icons">arrow_back</i> Go back</span>
            </p>
            <Helmet>
                <meta name="robots" content="noindex" />
            </Helmet>
        </div>
    );
}


export default PoiListNone;


